<template>
    <button @click.prevent="removeItem" :disabled="busy" class="btn  btn--quaternary" type="button" name="button">
        {{ busy ? "Please wait..." : __("Remove") }}
    </button>
</template>

<script>
export default {
    name: "remove-button",
    props: ["index"],
    data() {
        return {
            busy: false
        };
    },
    methods: {
        removeItem() {
            this.busy = true;
            axios
                .post("/basket/remove", {
                    index: this.index
                })
                .then(response => {
                    window.location.reload();
                });
        }
    }
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// resources/js/components/Basket/Remove-from-cart.vue